/**
 * Lightweight state manager for cross-component state
 *
 * @package Felix
 */

class FelixState {
	constructor() {
		this.state = {}
		this.listeners = []
	}

	/**
	 * Set a state value
	 *
	 * @param {string} key   State key
	 * @param {*}      value State value
	 */
	set(key, value) {
		this.state[key] = value
		this.notify(key, value)
	}

	/**
	 * Get a state value
	 *
	 * @param {string} key State key
	 * @return {*} State value
	 */
	get(key) {
		return this.state[key]
	}

	/**
	 * Subscribe to state changes
	 *
	 * @param {Function} callback Callback function
	 */
	subscribe(callback) {
		this.listeners.push(callback)
	}

	/**
	 * Notify listeners of state change
	 *
	 * @param {string} key   State key
	 * @param {*}      value State value
	 */
	notify(key, value) {
		this.listeners.forEach((cb) => cb(key, value))
	}
}

export default new FelixState()
